import React from 'react'

const Project = ({Toggle , Mode, showNavbar, changeMode}) => {
  return (
    <>
    <div className='project-container'>

    </div>
    </>
  )
}

export default Project